import { ContentScheduleResponse } from '@wit-support/admin-contracts';
import { CONTENT_API_BASE as BASE, contentRequest as request } from '../api.js';
/** Ключ запроса расписания (внутри `CONTENT_KEY` — сбрасывается вместе с разделом). */
export const CONTENT_SCHEDULE_KEY = ['content', 'schedule'];
/** GET /schedule — расписание публикаций движка (только чтение). */
export function getContentSchedule() {
    return request(ContentScheduleResponse, `${BASE}/schedule`);
}
//# sourceMappingURL=schedule.js.map